<template>
    <div class="activity-list-section">
        <!-- 55 -->
        <!-- 5近期活动 -->
        <van-row class="activity-list-section-box" @click="go_detail(dataItem.content, dataItem)">
            <div class="activity-list-section-left">
                <van-image
                    fit="cover"
                    class="activity-list-section-left-img"
                    :src="dataItem.content.cover_img"
                    width="100%"
                    height="100%"
                />
                <div class="activity-list-section-left-top" v-if="dataItem.top == 1">
                    <img src="/static/bytx/tag_top.svg" alt="" />
                </div>
                <div v-else-if="dataItem.content.type_text === '直播中'" class="activity-list-section-left-zl active">
                    <img src="/static/bytx/activity_list_live_icon.gif" alt="" />直播中
                </div>
                <div v-else class="activity-list-section-left-zl">
                    {{ dataItem.type_text }}
                </div>
            </div>
            <div class="activity-list-section-right">
                <div class="activity-list-section-right-time">
                    <span> {{ dataItem.content.start_at }}-{{ dataItem.content.ends_at }}</span>
                    <span>{{ dataItem.content.status_text }}</span>
                </div>
                <div class="activity-list-section-right-title" v-html="dataItem.content.title"></div>
            </div>
            <div class="clear"></div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    name: 'Activity',
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    methods: {
        go_detail(item, i) {
            if (item.live_id > 0) {
                if (item.live.live_status === 0) {
                    this.$router.push({ name: 'live-detail', params: { id: item.live_id } })
                } else {
                    this.$router.push({ name: 'live-detail-home', params: { id: item.live_id } })
                }
            } else {
                this.$router.push({
                    name: 'activity-detail',
                    params: { id: item.id }
                })
            }
            Interface.getData('get', `/course-phase/api/recommend_v2/${i.id}/view`)
            // $router.push({ name: 'activity-detail', params: { id: dataItem.content.id } })
            Interface.mFootPrint(i.id,67,this.contentType,1,0,0,0,item.title, this.searchText)
        }
    }
}
</script>

<style lang="scss" scoped>
.activity-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &.false {
        display: none;
    }
    &.true {
        display: block;
    }

    &-box {
        width: 345px;
        border-bottom: 1px solid #f2f2f2;

        &:nth-last-child(1) {
            border: 0;
        }
    }

    &-left {
        width: 112px;
        height: 66px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
                img {
                    width: 10px;
                    height: 10px;
                }
            }
            img {
                width: 32px;
                height: 18px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 219px;
        text-align: left;

        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            margin-top: 6px;
            .light {
                color: #0fb7ad;
            }
        }

        &-tags {
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #f1a526;
            letter-spacing: 0;
            float: right;
            margin-right: 10px;
            img {
                width: 18px;
                height: 18px;
                margin-bottom: -5px;
            }

            &.active {
                color: #f1a526;
            }
            &.current {
                color: #f1a526;
            }
            &.appoint {
                color: #0fb7ad;
            }
            &.end {
                color: #adadaf;
            }
        }
    }

    .activity-list-section-left {
        width: 130px;
        height: 73px;
    }
    .activity-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 4px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
    .activity-list-section-left-zl {
        top: 4px;
        left: 4px;
        border-radius: 3px;
    }
    .activity-list-section-right {
        width: 191px;
        &-time {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-family: HarmonyOS_Sans_SC_Medium;
            background: transparent;
            color: #fea253;
            padding: 0;
            span:nth-child(1) {
                border-radius: 4px;
                font-size: 11px;
                background: #fff9f1;
                padding: 2px 6px;
            }
            span:nth-child(2) {
                font-size: 12px;
                margin-right: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/activity.vue